// Reducers
import {FETCH_ITEMS_FAILURE,FETCH_ITEMS_SUCCESS,FETCH_ITEMS_REQUEST, FETCH_PRODUCT_TYPES_FAILURE,FETCH_PRODUCT_TYPES_REQUEST,FETCH_PRODUCT_TYPES_SUCCESS} from '../actions/products'

const ProductsReducer = (state = { products: [], loading: true, error: null, productTypes: [], loadingProductTypes: false, errorProductTypes: null }, action) => {
    switch (action.type) {
      case FETCH_ITEMS_REQUEST:
        return { ...state, loading: true };
      case FETCH_ITEMS_SUCCESS:
        return { ...state, products: action.payload, loading: false };
      case FETCH_PRODUCT_TYPES_REQUEST:
        return { ...state, loadingProductTypes: true };
      case FETCH_PRODUCT_TYPES_SUCCESS:
        return { ...state, productTypes: action.payload, loadingProductTypes: false };
      case FETCH_PRODUCT_TYPES_FAILURE:
        return { ...state, errorProductTypes: action.payload, loadingProductTypes: false };
      case FETCH_ITEMS_FAILURE:
        return { ...state, error: action.payload, loading: false };
      default:
        return state;
    }
  };
export default ProductsReducer;